(function () {
    'use strict';

    angular
            .module('imnApp')
            .directive('cancelEvent', cancelEvent);

    function cancelEvent() {
        return {
            restrict: 'A',
            link: function (scope, element, attr) {
                element.on(attr.cancelEvent, function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                });
            }
        }
    }

})();